<div class="data-table-wrapper" [class.data-table-wrapper--loading]="loading">
  <!-- Loading Overlay -->
  @if (loading) {
    <div class="data-table__loading-overlay">
      <app-spinner [centered]="true"></app-spinner>
    </div>
  }

  <!-- Table Container -->
  <div class="table-responsive">
    <table [class]="tableClass">
      <!-- Table Header -->
      <thead>
        <tr>
          <!-- Selection Checkbox Column -->
          @if (selectable) {
            <th class="data-table__checkbox-cell w-40">
              <hc-checkbox
                [ngModel]="isAllSelected"
                [ngModelOptions]="{standalone: true}"
                [indeterminate]="isIndeterminate"
                (changed)="onMasterCheckboxChange($event)">
              </hc-checkbox>
            </th>
          }

          <!-- Data Columns -->
          @for (column of visibleColumns; track column.key) {
            <th
              [class.sortable]="column.sortable"
              [class.data-table__header--sorted]="sortColumn === (column.sortKey ?? column.key)"
              [style.width]="column.width"
              [style.textAlign]="column.align || 'left'"
              [class]="column.cssClass || ''"
              [attr.role]="column.sortable ? 'button' : null"
              [attr.tabindex]="column.sortable ? 0 : null"
              (click)="column.sortable && onHeaderClick(column)"
              (keydown)="column.sortable && onHeaderKeydown($event, column)">

              <!-- Custom Header Template -->
              @if (column.headerTemplate) {
                <ng-container
                  *ngTemplateOutlet="column.headerTemplate; context: getHeaderContext(column)">
                </ng-container>
              } @else {
                <!-- Default Header Content -->
                {{ column.label | translate }}
                @if (column.sortable) {
                  <lucide-icon name="unfold-vertical" [size]="16" class="ms-1 data-table__sort-icon"></lucide-icon>
                }
              }
            </th>
          }
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        @if (displayData.length > 0) {
          @for (row of displayData; track trackByFn($index, row); let rowIndex = $index) {
            <tr
              [class.clickable-row]="rowClickable"
              (click)="rowClickable && onRowClick(row, rowIndex, $event)">

              <!-- Selection Checkbox Cell -->
              @if (selectable) {
                <td class="data-table__checkbox-cell" (click)="$event.stopPropagation()">
                  <hc-checkbox
                    [ngModel]="isRowSelected(row)"
                    [ngModelOptions]="{standalone: true}"
                    (changed)="onRowCheckboxChange(row)">
                  </hc-checkbox>
                </td>
              }

              <!-- Data Cells -->
              @for (column of visibleColumns; track column.key) {
                <td
                  [style.textAlign]="column.align || 'left'"
                  [class]="column.cssClass || ''"
                  [class.actions-cell]="isActionColumn(column)"
                  (click)="isActionColumn(column) && $event.stopPropagation()">

                  <!-- Custom Cell Template -->
                  @if (column.cellTemplate) {
                    <ng-container
                      *ngTemplateOutlet="column.cellTemplate; context: getCellContext(row, column, rowIndex)">
                    </ng-container>
                  } @else {
                    <!-- Default Cell Content -->
                    {{ getCellValue(row, column.key) }}
                  }
                </td>
              }
            </tr>
          }
        } @else if (showEmptyState && !loading && totalItems === 0) {
          <!-- Empty State Row -->
          <tr>
            <td [attr.colspan]="totalColumnCount">
              <app-empty-state
                [icon]="emptyIcon"
                [title]="emptyTitle"
                [description]="emptyDescription">
              </app-empty-state>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  @if (paginated && totalItems > 0) {
    <div class="data-table__pagination">
      <hc-pagination
        [page]="page"
        [perPage]="pageSize"
        [total]="totalItems"
        [pageSizeOptions]="pageSizeOptions"
        [showPageSizeSelector]="showPageSizeSelector"
        (pageChange)="onPageChange($event)">
      </hc-pagination>
    </div>
  }
</div>
